/**
 * Extracts accessible speech text from HTML content.
 *
 * This function looks for:
 * - Images with alt text
 * - Spans with data-mathml attribute and title text
 */
export function extractSpeechTextFromContent(
  containerElement: HTMLElement,
): string | null;
export function extractSpeechTextFromContent(
  htmlContent: string,
): string | null;
export function extractSpeechTextFromContent(
  input: HTMLElement | string,
): string | null {
  const speechTexts: string[] = [];

  let containerElement: HTMLElement;

  // Handle string input by creating a temporary DOM element
  if (typeof input === "string") {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = input;
    containerElement = tempDiv;
  } else {
    containerElement = input;
  }

  // 1. Extract alt text from images
  const imgElements = containerElement.querySelectorAll("img[alt]");
  if (imgElements.length > 0) {
    const imgAltTexts = Array.from(imgElements)
      .map((img) => img.getAttribute("alt"))
      .filter((alt): alt is string => Boolean(alt?.trim()));
    speechTexts.push(...imgAltTexts);
  }

  // 2. Extract title text from spans with data-mathml attribute
  const mathSpans = containerElement.querySelectorAll(
    "span[data-mathml][title]",
  );
  if (mathSpans.length > 0) {
    const mathTitles = Array.from(mathSpans)
      .map((span) => span.getAttribute("title"))
      .filter((title): title is string => Boolean(title?.trim()));
    speechTexts.push(...mathTitles);
  }

  if (speechTexts.length > 0) {
    return speechTexts.join(" ");
  }

  return null;
}
